<template>
  <div class="column_center_around order_method_container">
    <!-- <div v-if="storeHasDineInTables" class="table_select" :class="tableName ? 'row_center_center' : 'row_center_between'" @click="showTableOption = true">
      <text class="text-center font-normal" :class="tableName ? 'text-black' : 'text-[rgba(0,0,0,0.3)]'">{{ tableName || '請選擇桌號' }}</text>
      <text id="expand_more" class="button-icon" style="color: #FBCB02; font-size: 28px; width: 28px; height: 28px;"
        v-if="!tableName">expand_more</text>
    </div> -->
    
    <!-- 整合 InvoiceSelector 組件 -->
    <InvoiceSelector 
      ref="invoiceSelectorRef"
      v-if="shouldShowInvoiceSelector"
      @invoice-updated="handleInvoiceUpdated"
      @validation-error="handleValidationError"
    />
    
    <!--
    <button class="button" @click="toOrderPage">開始點餐</button>
    -->
    <button class="button" @click="toOrderPage">外帶點餐</button>
    <div class="w-full mt-5 mb-2 row_center_center" v-if="toGoDelayMinute !== 0">
      現場外帶需等候{{ toGoDelayMinute }}分鐘
    </div>
    <SelectDineInTable :tableOptions="dineInTables" v-if="showTableOption" @close="showTableOption = false" @setTable="setTableData" />
  </div>
</template>
<script>
import commonUtilities from "@/utils/common.utils";
import selectDineInTable from "./selectDineInTable.vue";
import InvoiceSelector from "./InvoiceSelector.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    SelectDineInTable: selectDineInTable,
    InvoiceSelector,
  },
  data() {
    return {
      tableData: {},
      showTableOption: false
    };
  },
  computed: {
    getCurrentStore() {
      return this.$store.state.basic.currentStore;
    },
    dineInTables() {
      return this.$store.getters['spreadsheet/dineInTables']
    },
    tableIndex() {
      return this.$store.getters['cart/tableIndex']
    },
    storeHasDineInTables() {
      return this.dineInTables.length >= 1
    },
    ...mapGetters('cart', {
      tableName: 'tableName',
      tableAreaId: 'tableAreaId',
      tableIndex: 'tableIndex',
    }),
    ...mapGetters('basic', {
      toGoDelayMinute: 'toGoDelayMinute',
      toGoDelayHour: 'toGoDelayHour'
    }),
    // 判斷是否顯示發票選項
    shouldShowInvoiceSelector() {
      return this.$store.getters['basic/enableInvoiceSelector']
    }
  },
  methods: {
    toOrderPage() {
      // 觸發所有輸入框失焦，確保發票資料已更新
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur()
      }
      
      // 驗證發票資訊
      if (this.shouldShowInvoiceSelector && this.$refs.invoiceSelectorRef) {
        if (!this.$refs.invoiceSelectorRef.validate()) {
          commonUtilities.createToast('error', '請檢查發票資訊格式')
          return
        }
      }
      
      if (!this.areaId || !this.tableName) {
        const data = {
            areaId: null,
            tableIndex: -1
        }
        console.log('to go table selection', data)
        this.$store.commit('cart/setTableData', data)
      }
      
      // payment 物件已經包含最新的發票資料（由 InvoiceSelector 即時更新）
      // 不需要額外處理，直接使用即可
      
      const data = {
        method: 'takeOut'
      }
      this.$emit('toOrderPage', data)
    },
    
    // 處理發票資料更新事件
    handleInvoiceUpdated(invoiceData) {
      console.log('toGo.vue 收到發票資料更新:', invoiceData)
      // InvoiceSelector 已經更新了 Vuex store，這裡只需要記錄日誌
    },
    
    // 處理發票驗證錯誤事件
    handleValidationError(errorMessage) {
      console.error('toGo.vue 收到發票驗證錯誤:', errorMessage)
      // 可以選擇顯示錯誤訊息給使用者
      // commonUtilities.createToast('error', errorMessage)
    }
  },
};
</script>
<style lang="scss" scoped>
.table_select {
  width: 100%;
  height: 54px;
  padding: 0 4%;
  border: #AAAAAA 1px solid;
  border-radius: 6px;
  color: #000;
  font-size: 22px;
  font-weight: 500;
  font-family: PingFang SC;
  margin: 18px 0 15px;
}
</style>
